// The one confirm sheet for anything that moves money (gap #8, payroll's funding): the outcome said
// in words before the person decides, what it needs, and a danger button that names the amount.

import { useEffect, useRef, type ReactNode } from 'react';
import './money-sheet.css';

export function MoneySheet({
  title,
  outcome,
  children,
  confirm,
  ready,
  busy,
  error,
  note,
  onConfirm,
  onClose,
}: {
  title: string;
  outcome: ReactNode;
  children?: ReactNode;
  confirm: string;
  ready: boolean;
  busy: boolean;
  error: string | null;
  note?: ReactNode;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (d && !d.open) d.showModal();
  }, []);
  return (
    <dialog ref={ref} className="sheet ask money-sheet" aria-labelledby="money-sheet-title" onClose={onClose}>
      <form
        method="dialog"
        onSubmit={(e) => {
          e.preventDefault();
          if (ready && !busy) onConfirm();
        }}
      >
        <h3 id="money-sheet-title" className="sheet-title">
          {title}
        </h3>
        <p className="money-outcome">{outcome}</p>
        {children}
        {note}
        {error && (
          <p className="error" role="alert">
            {error}
          </p>
        )}
        <div className="row end">
          <button type="button" className="btn soft" onClick={() => ref.current?.close()} disabled={busy}>
            Cancel
          </button>
          <button type="submit" className="btn danger" disabled={!ready || busy}>
            {busy ? 'Working…' : confirm}
          </button>
        </div>
      </form>
    </dialog>
  );
}
